export const GET_SERVICE_PROVIDER = "GET_SERVICE_PROVIDER";
export const GET_ALL_SERVICE_PROVIDER = "GET_ALL_SERVICE_PROVIDER";
export const ADD_NEW_SERVICE_PROVIDER = "ADD_NEW_SERVICE_PROVIDER";
